import {
  ClipSceneIcon,
  ClipSceneSubmenu,
} from "@/components/ui/clip-scene-tool-ui";
import { ToolName } from "@/store/ui/ui-slice";
import { FaroTooltip, ToolButton, Toolbar } from "@faro-lotv/flat-ui";
import { Popper } from "@mui/material";
import { useRef, type JSX } from "react";

interface DataPreparationToolsToolbarProps {
  /** The currently active tool */
  activeTool?: ToolName;

  /** Callback when the user requests to toggle a tool*/
  onToggleTool(toggleTool: ToolName): void;
}

/** @returns the tools toolbar for the data-preparation tool */
export function DataPreparationToolsToolbar({
  activeTool,
  onToggleTool,
}: DataPreparationToolsToolbarProps): JSX.Element {
  const clipSceneToolButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Toolbar>
        <FaroTooltip title="Clipping box">
          <ToolButton
            aria-label="clipping box"
            ref={clipSceneToolButtonRef}
            onClick={() => onToggleTool(ToolName.clipScene)}
            selected={activeTool === ToolName.clipScene}
          >
            <ClipSceneIcon />
          </ToolButton>
        </FaroTooltip>
      </Toolbar>

      <Popper
        open={activeTool === ToolName.clipScene}
        anchorEl={clipSceneToolButtonRef.current}
        placement="left"
        sx={{ p: 1 }}
      >
        <ClipSceneSubmenu />
      </Popper>
    </>
  );
}
